/**
 * Dispatch event on click outside of node and included node
 * @date 2021-01-11
 * @param {HTMLElement} node
 * @param {HTMLElement} includeNode
 * @returns {Object} methods
 */
export function clickOutside(node, includeNode = undefined) {
  const handleClick = (event) => {
    // Bail early on included element
    if (
      includeNode &&
      (includeNode === event.target || includeNode.contains(event.target))
    )
      return;

    if (node && !node.contains(event.target) && !event.defaultPrevented) {
      node.dispatchEvent(new CustomEvent('click-outside', node));
    }
  };

  document.addEventListener('click', handleClick, true);

  return {
    update(newIncludeNode) {
      includeNode = newIncludeNode;
    },
    destroy() {
      document.removeEventListener('click', handleClick, true);
    },
  };
}
